import gql from 'graphql-tag'
import {useMutation} from '@apollo/client'

const UPDATE_SAVED_FILTER = gql`
  mutation updateSavedFilter($saved_filter_name: String!, $updated_saved_filter_name: String!) {
    updateSavedFilter(saved_filter_name: $saved_filter_name, updated_saved_filter_name: $updated_saved_filter_name) {
      success
      message
      saved_filter_name
    }
  }
`

export default function useUpdateSavedFilter() {
  const [updateSavedFilter, {data, loading, error}] = useMutation(UPDATE_SAVED_FILTER, {
    errorPolicy: 'all'
  })

  return {updateSavedFilter, data, loading, error}
}
